<mat-card-header class="flex align-items-center">
  <shared-title>Editar Parámetro</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>
<form [formGroup]="parametersForm">
  <mat-dialog-content>
    <div class="w-full gap-1 flex flex-column">
      <mat-label style="font-size: large; margin-bottom: 15px"
        ><strong>Parámetro: </strong>{{ header() }}</mat-label
      >

      <mat-label style="font-size: large; margin-bottom: 15px"
        ><strong>Descripción: </strong>{{ desciption() }}</mat-label
      >
      <!--!Inicio de codigo para correos-->
      @if (this.header() === 'Servidor correo') {
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Correo:</mat-label>
          <input
            [errorStateMatcher]="matcher"
            matInput
            formControlName="senderParameter"
            type="email" />
          @if (parametersForm.controls['senderParameter'].hasError('email')) {
            <mat-error>
              <small>Este campo debe ser un email válido. </small>
            </mat-error>
          }
          @if (
            parametersForm.controls['senderParameter'].hasError('required')
          ) {
            <mat-error>
              <small>El valor es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Contraseña:</mat-label>
          <input
            [errorStateMatcher]="matcher"
            matInput
            formControlName="senderPasswordParameter"
            type="text" />
          @if (
            parametersForm.controls['senderPasswordParameter'].hasError(
              'required'
            )
          ) {
            <mat-error>
              <small>El valor es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Host:</mat-label>
          <input
            [errorStateMatcher]="matcher"
            matInput
            formControlName="senderHost"
            type="text" />
          @if (parametersForm.controls['senderHost'].hasError('required')) {
            <mat-error>
              <small>El valor es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Puerto:</mat-label>
          <input
            [errorStateMatcher]="matcher"
            matInput
            formControlName="senderPortParameter"
            (keydown)="onKeyDown($event)"
            type="number" />
          @if (
            parametersForm.controls['senderPortParameter'].hasError('required')
          ) {
            <mat-error>
              <small>El valor es <strong>requerido</strong> </small>
            </mat-error>
          }
          @if (
            parametersForm.controls['senderPortParameter'].hasError('maxLength')
          ) {
            <mat-error>
              <small>Este campo debe tener como máximo 4 caracteres. </small>
            </mat-error>
          }
          @if (
            parametersForm.controls['senderPortParameter'].hasError('minLength')
          ) {
            <mat-error>
              <small>Este campo debe tener como mínimo 2 caracteres. </small>
            </mat-error>
          }
        </mat-form-field>
      } @else {
        <!--! Fin codigo para correos.-->
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>{{ dimension() }}</mat-label>
          <input
            [errorStateMatcher]="matcher"
            matInput
            formControlName="value"
            [type]="type()"
            (keydown)="onKeyDown($event)" />
          @if (parametersForm.controls['value'].hasError('required')) {
            <mat-error>
              <small>El valor es <strong>requerido</strong> </small>
            </mat-error>
          }
          @if (parametersForm.controls['value'].hasError('maxlength')) {
            <mat-error>
              <small
                >Este campo debe tener como máximo {{ maxLength() }} caracteres.
              </small>
            </mat-error>
          }
          @if (parametersForm.controls['value'].hasError('numberRangeError')) {
            <mat-error>
              <small
                >El valor está fuera del rango permitido ({{
                  this.minValue()
                }}
                - {{ this.maxValue() }}).
              </small>
            </mat-error>
          }
          @if (parametersForm.controls['value'].hasError('email')) {
            <mat-error>
              <small>Este campo debe ser un email válido. </small>
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar</shared-button
    >

    <shared-button
      [disabled]="!parametersForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'"
      (click)="submit()"
      >Guardar</shared-button
    >
  </mat-dialog-actions>
</form>
@if (this.data.action.key === 'Mensaje correo contraseña') {
  <mat-accordion>
    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header>
        <mat-panel-title> ¿Necesitas un ejemplo? </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        {{ messageHelpPassword() }}
      </p>
    </mat-expansion-panel>
  </mat-accordion>
}
